import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import UserGoldCalendar from '@/components/UserGoldCalendar';

const GoldCalendarPage = ({ user }) => {
  const navigate = useNavigate();
  const userPlan = user?.subscription_plan?.toLowerCase() || 'free';
  
  // Solo usuarios Gold o superiores pueden acceder
  const hasAccess = ['gold', 'vip', 'lifetime', 'competitive', 'competitivo'].includes(userPlan) || user?.role === 'admin';
  
  useEffect(() => {
    if (!hasAccess) {
      navigate('/dashboard');
    }
  }, [hasAccess, navigate]);
  
  if (!hasAccess) {
    return null;
  }
  
  return (
    <div 
      className="min-h-screen py-8 px-4"
      style={{ backgroundColor: '#0a0a0a' }}
    >
      <div className="max-w-6xl mx-auto">
        <UserGoldCalendar user={user} />
      </div>
    </div>
  );
};

export default GoldCalendarPage;
